import type { HelpFile } from '../../types/help'
import { NotFoundTestIds } from '../../../testids/NotFoundTestIds'

export const notFoundHelp: HelpFile = {
  texts: {
    [NotFoundTestIds.btnBackToDashboard]: null,
    [NotFoundTestIds.linkBackToDashboard]: null,
  },
}
